import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";

import TaskDrawer from "../tasks/TaskDrawer";
import TaskBoard from "../tasks/TaskBoard";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import "../tasks/tasks.css";

// A ticket's tasks on the shared task board, with work/pause/check timers on each card.
const TTTable = ({ ticketid, ticketTitle }) => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const getTasks = async () => {
    if (!ticketid) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/by-ticket/${ticketid}`,
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      setData(res.data || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    getTasks();
    // Keeps timers and statuses in sync with colleagues working on the same ticket.
    const interval = setInterval(getTasks, 15000);
    return () => clearInterval(interval);
  }, [ticketid]);

  return (
    <div className="desk-wrapper desk-wrapper--embedded">
      <div className="desk-topbar">
        <div className="desk-topbar__left">
          <h2 className="desk-topbar__title">{ticketTitle || t("Kanban Flow")}</h2>
          <span className="desk-topbar__count">
            {data.length} {t("Tasks")}
          </span>
        </div>
        <MainButtonComp text={t("Add Task")} addBtn onClick={() => setDrawerOpen(true)} />
      </div>

      <Spin spinning={loading}>
        <TaskBoard tasks={data} onChanged={getTasks} showTimer />
      </Spin>

      <TaskDrawer
        mode="add"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        updateParent={getTasks}
        ticketId={ticketid}
      />
    </div>
  );
};

export default TTTable;
